import { MenuButton } from '@/src/components/ui/Menu'
import { useCompanyLogo } from '@/src/hooks/useCompanyLogo.hook'
import { useSessionStore } from '@/src/hooks/use_session_store'
import { useNavbarCollapsedStore } from '@/src/shared/infrastructure/useNavbarCollapsedStore'
import { Box, Image, Text } from '@chakra-ui/react'
import { FlexRow } from '@components'
import { LuBuilding2 } from 'react-icons/lu'
import { LuChevronsUpDown } from 'react-icons/lu'

interface CompanySelectButtonProps {
  disabled: boolean
}

export const CompanySelectButton = ({ disabled }: CompanySelectButtonProps) => {
  const session = useSessionStore()
  const { isCollapsed } = useNavbarCollapsedStore.getState()

  const companyName = session.user?.company?.title || session.user?.companyName || ''
  const logoId = session.user?.company.logoId
  const companyId = session.user?.company.id

  const { data: logoUrl } = useCompanyLogo(companyId, logoId)

  return (
    <MenuButton
      alignItems={'center'}
      w='100%'
      padding={'4px'}
      h='32px'
      mr={isCollapsed ? '-12px' : '8px'}
      borderRadius='4px'
      borderWidth={'0px'}
      justifyContent={'space-between'}
      _hover={{ backgroundColor: disabled ? 'transparent' : 'accent' }}
      isDisabled={disabled}
      opacity={1}
      color={'black!'}
      cursor={disabled ? 'default' : 'pointer'}
      _disabled={{
        opacity: 1,
        color: 'black!',
        backgroundColor: 'transparent',
      }}
    >
      {isCollapsed ? (
        <Box paddingX={'11.6px'}>
          <LuBuilding2 width={'24px'} height={'24px'} />
        </Box>
      ) : (
        <FlexRow alignItems={'center'} justifyContent={'space-between'}>
          <FlexRow alignItems={'center'} gap='4px'>
            {!!logoUrl && <Image borderRadius='2px' objectFit='cover' src={logoUrl} w='24px' h='24px' />}
            <Text fontWeight={'bold'} textAlign='left' fontSize='12px' lineHeight='14px' noOfLines={2} ml='4px' whiteSpace='normal'>
              {companyName}
            </Text>
          </FlexRow>
          {!disabled && <LuChevronsUpDown size={18} style={{ flexShrink: 0 }} />}
        </FlexRow>
      )}
    </MenuButton>
  )
}
